export default __webpack_public_path__ + "static/green-15ed9a4def6c9385e00cd2adf4c5930d.png";